import { createContext, Dispatch, useContext, useEffect, useReducer } from "react";
import { useLocalStorage } from "usehooks-ts";
import { setAuthTokenHeaders } from "../../../api/api";
import { getCustomer } from "../../../api/customer";
import { capture } from "../../../shared/capture";
import { AppStateActionType } from "../../contexts/app/reducer";
import { Analytics } from "../../shared/analytics";
import Constants from "../../shared/contants";
import { fetchUserKey, fetchUserToken } from "../../shared/util";
import { AppState, AppStateAction, initialState, reducer } from "./reducer";

interface IAppStateContext {
  state: AppState;
  dispatch: Dispatch<AppStateAction>;
}

export const AppStateContext = createContext<IAppStateContext>({
  state: initialState,
  dispatch: () => null,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AppStateProvider = ({ children }: { children: any }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isSandbox] = useLocalStorage<boolean>(Constants.isSandboxKey, false);

  useEffect(() => {
    async function fetchData() {
      try {
        const token = await fetchUserToken();
        setAuthTokenHeaders(token);

        const customer = await getCustomer();
        const keys = await fetchUserKey();

        Analytics.identify(customer.id);

        dispatch({
          type: AppStateActionType.update,
          newState: {
            authToken: token,
            customer,
            isLoaded: true,
            keys,
          },
        });
      } catch (err) {
        capture.error(err, { extra: { context: `app.state.init` } });
      }
    }
    fetchData();
  }, [isSandbox]);

  return (
    <AppStateContext.Provider value={{ state, dispatch }}>{children}</AppStateContext.Provider>
  );
};

export const useAppContext = () => useContext(AppStateContext);
